const AUTH_INTENT_STORAGE_KEY = 'inhound:auth:return-to';

export function buildAuthHref(returnTo?: string | null): string {
  if (!returnTo) return '/auth';
  return `/auth?returnTo=${encodeURIComponent(returnTo)}`;
}

export function rememberAuthIntent(returnTo: string) {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(AUTH_INTENT_STORAGE_KEY, returnTo);
}

export function consumeAuthIntent(fallback = '/profile'): string {
  if (typeof window === 'undefined') return fallback;

  const stored = window.sessionStorage.getItem(AUTH_INTENT_STORAGE_KEY);
  if (stored) {
    window.sessionStorage.removeItem(AUTH_INTENT_STORAGE_KEY);
    return stored;
  }

  return fallback;
}

export function resolveReturnTo(search: string): string | null {
  const params = new URLSearchParams(search);
  const value = params.get('returnTo');
  if (!value || !value.startsWith('/')) {
    return null;
  }
  return value;
}
